var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',[_vm._v(_vm._s(_vm.mensaje))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }